'use client';

import { c as _c } from "react/compiler-runtime";
import type { RsGroupCostType } from '@/modules/__generated__/graphql/switchboard-generated';
import { usePricingCalculatorContext } from '@/modules/service-purchase/providers/pricing-calculator-provider';
import type { CatalogStatus } from '@/modules/service-purchase/types';
import { SectionHeader } from './section-header';
export interface ServiceCatalogHeaderProps {
  title: string;
  badge?: CatalogStatus;
  hasToggle?: boolean;
  toggleLabel?: string;
  toggleEnabled?: boolean;
  onToggleChange?: (enabled: boolean) => void;
  groupPrice?: number | null;
  groupDiscountedPrice?: number | null;
  groupCurrency?: string | null;
  groupCostType?: RsGroupCostType | null;
  perTierPrices?: Record<string, string | null> | null;
  isAddOn?: boolean;
  groupSetupPrice?: number | null;
}
function ServiceCatalogHeader(t0) {
  const $ = _c(15);
  const {
    title,
    badge,
    hasToggle,
    toggleLabel,
    toggleEnabled: t1,
    onToggleChange,
    groupPrice,
    groupDiscountedPrice,
    groupCurrency,
    groupCostType,
    perTierPrices,
    isAddOn,
    groupSetupPrice
  } = t0;
  const toggleEnabled = t1 === undefined ? false : t1;
  const {
    activePlan
  } = usePricingCalculatorContext();
  let t2;
  if ($[0] !== activePlan || $[1] !== badge || $[2] !== groupCostType || $[3] !== groupCurrency || $[4] !== groupDiscountedPrice || $[5] !== groupPrice || $[6] !== groupSetupPrice || $[7] !== hasToggle || $[8] !== isAddOn || $[9] !== onToggleChange || $[10] !== perTierPrices || $[11] !== title || $[12] !== toggleEnabled || $[13] !== toggleLabel) {
    t2 = <SectionHeader title={title} badge={badge} hasToggle={hasToggle} toggleLabel={toggleLabel} toggleEnabled={toggleEnabled} onToggleChange={onToggleChange} activePlan={activePlan} groupPrice={groupPrice} groupDiscountedPrice={groupDiscountedPrice} groupCurrency={groupCurrency} groupCostType={groupCostType} perTierPrices={perTierPrices} isAddOn={isAddOn} groupSetupPrice={groupSetupPrice} />;
    $[0] = activePlan;
    $[1] = badge;
    $[2] = groupCostType;
    $[3] = groupCurrency;
    $[4] = groupDiscountedPrice;
    $[5] = groupPrice;
    $[6] = groupSetupPrice;
    $[7] = hasToggle;
    $[8] = isAddOn;
    $[9] = onToggleChange;
    $[10] = perTierPrices;
    $[11] = title;
    $[12] = toggleEnabled;
    $[13] = toggleLabel;
    $[14] = t2;
  } else {
    t2 = $[14];
  }
  return t2;
}
export { ServiceCatalogHeader };